import { HttpClient } from '@angular/common/http';
import { CountryType } from '../types/country.type';
import { CONSTANTS } from '../constants/constants';
import { Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CountriesHttp {
  private countries: CountryType[];

  constructor(private readonly http: HttpClient) {}

  getCountries(): Observable<CountryType[]> {
    if (this.countries) {
      return new Observable((subscriber) => {
        subscriber.next(this.countries);
      });
    }

    return this.http.get<CountryType[]>(`${CONSTANTS.BASE_API}countries`).pipe(
      tap((res) => {
        this.countries = res;
      })
    );
  }
}
